// extracted by mini-css-extract-plugin
module.exports = {"select":"MuiSelect-select-1AGELB","label":"MuiSelect-label-3rFxxk","option":"MuiSelect-option-2E4MGm"};